//引入Vue
import Vue from "vue";
//引入App
import App from './App';
// 引入Store
import store from './store'
//引入 vue-router
import VueRoutter from 'vue-router';
// 引入 router 对象
import router from './router'
// element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
// 引入语言包
import VueI18n from 'vue-i18n'   // 1. 引入插件
import en from './lang/en'       // 2. 引入英文语言包
import zh from './lang/zh'       // 2. 引入中文语言包
Vue.use(VueI18n) // 3. 安装插件
// 4. 创建 i18n 实例
const savedLang = localStorage.getItem('lang') || 'zh';
const i18n = new VueI18n({
  locale: savedLang,     // 设置当前默认语言为中文
  fallbackLocale: 'zh', // 当找不到指定语言文案时，回退到中文，这能有效避免页面显示空白[citation:2]
  messages: {       // 注册语言包
    en,
    zh
  }
})
// 引入动画
import 'animate.css'
// import animate from 'animate.css'
// Vue.use(animate);
// 引入mixin主
import { mixin, shareData } from "@/js/mixin";
Vue.mixin(mixin);
// Vue.mixin(shareData);
//引入判断函数
import regular from '@/js/regular.js';
Vue.prototype.$regular = regular;
//全局过滤器
import filters from '@/js/filter.js';
Object.keys(filters).forEach(key=>{
    Vue.filter(key,filters[key])
})
// 全局事件总线
Vue.prototype.$bus = new Vue()
//关闭Vue的生产提示
Vue.config.productionTip = false;
Vue.use(VueRoutter)
// Vue
new Vue({
    el: '#app',
    render: h => h(App),
	i18n,
    store,
    router,
    beforeCreate(){
        Vue.prototype.$bus = this
    },
});

